export default __webpack_public_path__ + "static/2-693bbd29613932984ad14bddddee2eea.png";